module.exports = __webpack_public_path__ + "img/other.b4f736d8.png";